import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Loader from '../component/Loader'
import EventCard from '../component/EventCard'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import OtherService from '../services/Other'
import PageTitle from '../component/PageTitle'
import newsDefaultImage from '../assets/images/newsDefault.png'
import ColorCalender from '../assets/images/calendar.png'
import LocationPin from '../assets/images/map-pin.png'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import { useNavigate } from 'react-router-dom'

const HierarchyEventList = () => {
  const [visibleItemCount, setVisibleItemCount] = useState(12);
  const handleShowMore = () => {
    setVisibleItemCount(prevCount => prevCount + 12);
};
  //Format Date
  const formatDate = (date) => {
    const dateTime = new Date(date);
    return dateTime.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: true,
    });
  };
  const [isEventListAll, setIsEventListAll] = useState([])
  const [isEventListData, setIsEventListData] = useState(false)
  //Loader
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  //Upcoming Events
  useEffect(() => {
    const upComingEventsFetch = async () => {
      try {
        const token = localStorage.getItem('access_token');
        const userInfo = JSON.parse(localStorage.getItem('userData'));
        const hierarchyId = userInfo.dcm_hierarchies_id;
        const upComingEventsResponse = await OtherService.eventListByHierarchyId(hierarchyId)
        
        if (!upComingEventsResponse.error && upComingEventsResponse.data.data.length > 0) {
          setIsEventListAll(upComingEventsResponse.data.data)
          setLoading(false)
        }
        else {

          setLoading(false)
          setIsEventListData(true)
        }
      }

      catch (error) {
        console.error('upComing Events Fetch')

      }

    }
    upComingEventsFetch()
  }, [])
  const handleEventReadMore = (eventId) =>{
    navigate(`/hierarchyEventList/${eventId}`)
  }
  return (
    <>
    {loading && <Loader />}
     <BreadCrumbSecttion
        pageTitle="Event List"
        currentPageName="Event List" />
      <section className='padTop50'>
        <div className="dashboard-details">
          <Container>
            <Row>
              <Col xs={12}>
                <PageTitle blockTitle='Events List' />
              </Col>
              {isEventListData && (
                <Col xs={12}>
                  <div className='noDataMsg'>No data found!</div>
                </Col>
              )}
              {!isEventListData &&
                <Col xs={12}>
                  <Row>
                    {isEventListAll?.slice(0, visibleItemCount).map((item, index) => {
                      const startDate = formatDate(item.eventStartDate)
                      const endDate = formatDate(item.eventEndDate)
                      return (
                        <Col xs={12} md={4} lg={3} key={index} className='hierEventCard'>
                          <EventCard
                            image={item?.contentFilesThumbnailImage == null ? newsDefaultImage : item.contentFilesThumbnailImage}
                            calenderImage={ColorCalender}
                            eventTitle={item?.eventName}
                            locationPin={LocationPin}
                            eventPlace={`${item?.cityName}, ${item?.stateName }`}
                            eventDesc={item?.eventDesc}
                            eventType={item?.eventType}
                            eventStartTime={startDate}
                            eventEndTime={endDate}
                            onClickViewDetails = {() => { handleEventReadMore(item.eventId) }}
                          />
                        </Col>
                      )

                    })}

                  </Row>
                </Col>
              }

            </Row>
            {visibleItemCount < isEventListAll.length && (
                       
                       <Row className='justify-content-center'>
                           <Col xs={12} lg={3}>
                               <PrimaryGradientButton onClick={handleShowMore} buttonText='Show More' />

                           </Col>
                       </Row>
                   
               )}
          </Container>
        </div>
      </section>

    </>
  )
}

export default HierarchyEventList